import script from "./keepTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./keepTickets.vue?vue&type=script&setup=true&lang=js"

import "./keepTickets.vue?vue&type=style&index=0&id=298ed9c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-298ed9c6"]])

export default __exports__